export default {
  'brand.name': 'USFans Spreadsheet',
  'nav.home': 'Inicio',
  'nav.guides': 'Guías',
  'nav.buyingGuide': 'Guía de compra',
  'nav.review': 'Reseña',
  'nav.shipping': 'Envío',
  'nav.safety': 'Seguridad',
  'nav.faq': 'FAQ',
  'nav.buyNow': 'Comprar ahora',
  'lang.label': 'Idioma',
  'lang.en': 'English',
  'lang.pl': 'Polski',
  'lang.es': 'Español',
  'lang.fr': 'Français',

  'footer.tagline': 'Un recurso informativo independiente sobre USFans Spreadsheet.',
  'footer.disclaimer': 'Este sitio web es un recurso informativo independiente. No está afiliado ni respaldado oficialmente por USFans, salvo que se indique explícitamente.',
  'footer.col.explore': 'Explorar',
  'footer.col.guides': 'Guías',
  'footer.col.legal': 'Legal',
  'footer.about': 'Acerca de',
  'footer.contact': 'Contacto',
  'footer.privacy': 'Privacidad',
  'footer.terms': 'Términos',
  'footer.disclaimerLink': 'Aviso legal',
  'footer.copyright': '© 2026 USFans Spreadsheet. Todos los derechos reservados.',

  'common.readMore': 'Leer más',
  'common.backHome': 'Volver a la página de inicio',
  'common.explore': 'Explorar USFans Spreadsheet',
};